import { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/logoGU.png";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

// Fonts
const clashDisplay = { fontFamily: "'Clash Display', sans-serif" };
const manrope = { fontFamily: "'Manrope', sans-serif" };

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return alert("Veuillez entrer votre email.");
    alert(`Merci pour votre inscription, ${email}!`);
    setEmail("");
  };

  return (
    <footer className="relative w-full bg-white text-black mt-10 rounded-t-[70px] overflow-hidden">
      {/* --- Main Content Container --- */}
      <div className="max-w-8xl mx-auto px-6 lg:px-20 pb-5 pt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_2fr] gap-10 md:gap-12">
        {/* Left: Logo & Description */}
        <div className="flex flex-col gap-5">
          <img src={Logo} alt="Graphic Up" className="w-20" />
          <h2
            className="text-3xl font-bold bg-clip-text text-transparent"
            style={{
              backgroundImage:
                "linear-gradient(90deg, #158DC1, #FF6B6B, #FFD93D, #6BCB77)",
              ...clashDisplay,
            }}
          >
            Graphic Up
          </h2>
          {/* REMOVED FIXED WIDTH: w-[500px] max-w-[600px] */}
          <p
            className="text-base sm:text-lg md:text-p lg:text-p mb-1"
            style={manrope}
          >
            Votre partenaire de confiance pour sublimer chaque impression.
            Découvrez notre gamme complète de produits et solutions pour
            l&apos;impression professionnelle.
          </p>
          <div className="flex gap-4 text-xl">
            <a
              href="#"
              className="text-[#158DC1] hover:opacity-75 transition-all"
            >
              <FaFacebookF />
            </a>
            <a
              href="#"
              className="text-[#158DC1] hover:opacity-75 transition-all"
            >
              <FaInstagram />
            </a>
            <a
              href="#"
              className="text-[#158DC1] hover:opacity-75 transition-all"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Center: Links (Now visible from md screens and up) */}
        {/* This block is better served as a full column on medium screens (md) */}
        <div className="flex flex-col items-start text-left">
          <h3
            className="text-xl font-bold mb-6 text-[#158DC1]"
            style={clashDisplay}
          >
            Liens
          </h3>
          <ul className="space-y-3 text-base" style={manrope}>
            <li>
              <NavLink
                to="/"
                className="text-[#333333] text-p hover:text-[#158DC1] transition-all"
              >
                Accueil
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/produits"
                className="text-[#333333] text-p hover:text-[#158DC1] transition-all"
              >
                Produits
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/services"
                className="text-[#333333] text-p hover:text-[#158DC1] transition-all"
              >
                Services
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Contact"
                className="text-[#333333] text-p hover:text-[#158DC1] transition-all"
              >
                Contact
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/produits"
                className="text-[#333333] text-p hover:text-[#158DC1] transition-all"
              >
                Devis
              </NavLink>
            </li>
          </ul>
        </div>

        {/* Right: Subscribe + Contact */}
        {/* Max width is removed here as it was limiting flexibility */}
        <div className="flex flex-col gap-8">
          {/* Subscribe Form */}
          <div>
            <h3
              className="text-xl font-bold mb-4 text-[#158DC1]"
              style={clashDisplay}
            >
              S’abonner
            </h3>
            <form
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row w-full gap-2"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Entrez votre email"
                className="flex-1 px-4 py-3 rounded-t-xl sm:rounded-l-xl sm:rounded-tr-none border border-gray-300 focus:outline-none focus:border-[#158DC1]"
                style={manrope}
                required
              />
              <button
                type="submit"
                className="bg-[#158DC1] text-white px-6 py-3 rounded-b-xl sm:rounded-r-xl sm:rounded-bl-none hover:bg-[#0f6b94] transition-all"
                style={clashDisplay}
              >
                S’abonner
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div>
            <h3
              className="text-xl font-bold mb-4 text-[#158DC1]"
              style={clashDisplay}
            >
              Contact
            </h3>
            <ul
              className="space-y-3 text-base md:text-p lg:text-p font-light text-[#333333]"
              style={manrope}
            >
              <li>Email: graphic_up@outlook.com</li>
              <li>Téléphone: +216 52 213 300</li>
              <li>Adresse: Cité Mostakbal Fouchana, Ben Arous Tunisie</li>
            </ul>
          </div>
        </div>
      </div>

      {/* --- Bottom Bar --- */}
      <div className="border-t border-gray-200 my-8 pt-6">
        <p
          className="text-center text-sm font-light text-[#333333]"
          style={manrope}
        >
          © {new Date().getFullYear()} Graphic Up. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
};

export default Footer;